import './components/js-form-validator';
import './components/more';
import TetherSelect from 'tether-select';
import validatorOptions from './components/validatorOptions';

(function () {
  const donationForm = document.getElementById('donationForm');
  const submitButtons = donationForm.querySelectorAll('.form__submitButton');

  const validator = new Validator(
    donationForm,
    function (err, res) {
      return res;
    },
    validatorOptions
  );

  const radio = donationForm.querySelectorAll('input[name=donationForm__value]');
  const input = document.getElementById('donationForm__valueCustomValue');
  const radioCustom = document.getElementById('donationForm__valueCustom');

  input.addEventListener('click', () => {
    radioCustom.checked = true;
    if ('createEvent' in document) {
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('change', false, true);
      radioCustom.dispatchEvent(evt);
    } else radioCustom.fireEvent('onchange');
  });

  // Kwota własna jest wymagana tylko wtedy, gdy wybrano opcję „inna kwota".
  // Reguła min:1 odsiewa pusty string i tekst: bez niej (float)'abc' * 100 = 0
  // po stronie PHP (Przelewy24::prepareAmount) kończyło się odrzuceniem transakcji
  // przez bramkę już PO zapisaniu wpłaty w wp_wplaty.
  for (let i = 0; i < radio.length; i++) {
    radio[i].addEventListener('change', function () {
      if (this.value === 'custom') {
        // Parametry reguł rozdziela MYŚLNIK, nie dwukropek (js-form-validator.js:473).
        // Zapis 'min:1' jest cicho ignorowany jako nieznana reguła - wtedy 'abc' i '0'
        // przechodzą walidację i kończą się odrzuceniem transakcji przez bramkę.
        input.dataset.rule = 'required|min-1';
      } else {
        input.dataset.rule = '';
      }
      validator.reload();
    });
  }

  const destinationSelect = document.getElementById(
    'donationForm__destination'
  );

  const loveAdoptionWrapper = document.getElementById('loveAdoptionWrapper');
  const loveAdoptionSelect = loveAdoptionWrapper.querySelector('select');
  const projectWrapper = document.getElementById('projectWrapper');
  const projectSelect = projectWrapper.querySelector('select');

  // Wartości porównywane bez sufiksu ;#;ID — te dwie opcje celowo go nie mają.
  // Ten sam warunek jest po stronie PHP w Przelewy24::prepareFormData().
  destinationSelect.addEventListener('change', () => {
    loveAdoptionWrapper.style.display = 'none';
    projectWrapper.style.display = 'none';
    loveAdoptionSelect.dataset.rule = '';
    projectSelect.dataset.rule = '';

    switch (destinationSelect.value) {
      case 'WSPARCIE WYBRANEGO PROJEKTU':
        projectWrapper.style.display = 'block';
        projectSelect.dataset.rule = 'required';

        break;
      case 'ADOPCJA MIŁOŚCI':
        loveAdoptionWrapper.style.display = 'block';
        loveAdoptionSelect.dataset.rule = 'required';
    }

    validator.reload();
  });

  for (const element of donationForm.elements) {
    element.addEventListener('change', function () {
      setTimeout(function () {
        const isValid = validator.validate();
        for (const button of submitButtons) button.disabled = !isValid;
      }, 50);
    });

    element.addEventListener('keydown', function () {
      setTimeout(function () {
        if (validator.validate()) {
          for (const button of submitButtons) button.disabled = false;
        }
      }, 50);
    });
  }

  // TetherSelect celowo NIE jest podpinany na telefonach — zostaje natywny picker
  // systemowy, który jest tam lepszy niż podmieniona lista. Konsekwencja: w DOM
  // zostaje surowy <select>, a jego geometrię (wysokość 42px) trzyma reguła
  // `select:not(.select-select)` w src/scss/components/_form.scss. Bez niej etykieta
  // „notch" wchodzi na pole — patrz docs/propozycje-zmian.md, sekcja 11.
  // Detekcja po user agencie jest krucha; docelowo lepszy byłby
  // matchMedia('(pointer: coarse)').
  const selectFields = document.querySelectorAll('select');

  for (const select of selectFields) {
    if (!/Mobi|Android/i.test(navigator.userAgent)) {
      new TetherSelect({
        el: select,
        className: 'select-theme-swm',
      });
    }
  }
})();
